"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._ChooseSendOptions = exports._CMNTimeTableValid = exports.TIPOS_ENCAMINAMIENTO = exports.TESVALUES = exports.SEGMENT = exports.PHONE_COLORS = exports.DESTINO = void 0;
const PHONE_COLORS = {
  WHITE: 'white',
  BLACK: 'black',
  GREEN: 'green',
  BLUE: 'blue',
  GREY: 'grey',
  GREEN_REVERSE: 'green_reverse',
  BLUE_REVERSE: 'blue_reverse',
  GREY_REVERSE: 'grey_reverse',
  RED: 'red',
  RED_REVERSE: 'red_reverse',
  PURPLE: 'purple'
};
exports.PHONE_COLORS = PHONE_COLORS;
const DESTINO = {
  INSIDESALES: 'InsideSales',
  AVATAR: 'Avatar',
  FONDOS: 'Fondos',
  GEVICO: 'Gevico'
};
/**
 * Variable con los posibles valores de encaminamiento
 */

exports.DESTINO = DESTINO;
const TIPOS_ENCAMINAMIENTO = {
  SVC_A: 'SVC_A',
  SVC_B: 'SVC_B',
  SVC_C: 'SVC_C',
  ME_A: 'ME_A',
  ME_B: 'ME_B',
  ME_C: 'ME_C',
  FONINS_A: 'FONINS_A',
  FONINS_B: 'FONINS_B',
  FONINS_C: 'FONINS_C',
  FONINS_D: 'FONINS_D',
  FONINS_E: 'FONINS_E',
  FONGEV_A: 'FONGEV_A',
  FONGEV_B: 'FONGEV_B',
  FONGEV_C: 'FONGEV_C',
  FONGEV_D: 'FONGEV_D',
  FONGEV_E: 'FONGEV_E'
};
/**
 * Variable con los posibles valores de TES
 */

exports.TIPOS_ENCAMINAMIENTO = TIPOS_ENCAMINAMIENTO;
const TESVALUES = {
  SI: 'SI',
  NO: 'NO'
};
exports.TESVALUES = TESVALUES;
const SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
/**
 * Comprueba si estamos en horario de atencion valido
 * @returns {boolean} True si estamos dentro de horario, false si no
 */

exports.SEGMENT = SEGMENT;

const _CMNTimeTableValid = () => {
  try {
    const date = new Date();
    const hour = date.getHours();
    const day = date.getDay();

    if (hour >= 9 && hour < 19 && day < 6) {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
};
/**
 * Comprueba si estamos en horario de atencion valido
 * @returns {boolean} True si estamos dentro de horario, false si no
 */


exports._CMNTimeTableValid = _CMNTimeTableValid;

const _ChooseSendOptions = multipleOptions => {
  try {
    const random = Math.random() * 100;
    let auxRandom = 0;
    let chooseOption = 0;

    for (let i = 0; i < multipleOptions.length; i++) {
      if (parseInt(multipleOptions[i].porcentaje) + auxRandom > random) {
        chooseOption = i;
        break;
      } else {
        auxRandom += parseInt(multipleOptions[i].porcentaje);
      }
    }

    return multipleOptions[chooseOption];
  } catch (e) {
    return multipleOptions[0];
  }
};

exports._ChooseSendOptions = _ChooseSendOptions;

//# sourceMappingURL=utils.js.map